import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { OrderBumpModal } from './OrderBumpModal';
export function FinalCTASection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'pro'>('pro');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 24,
    minutes: 2,
    seconds: 29
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-76">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="w-full max-w-3xl flex flex-col items-center" data-id="element-77">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white text-center mb-6 uppercase italic" data-id="element-78">
          ELEGÍ TU <span className="text-brand-cyan" data-id="element-79">MEGAPACK</span>
        </h2>

        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mb-10 px-6 py-4 rounded-xl border border-red-500/20" style={{
        background: 'linear-gradient(135deg, rgba(239,68,68,0.06) 0%, rgba(239,68,68,0.02) 100%)',
        boxShadow: '0 0 30px rgba(239,68,68,0.08), 0 0 60px rgba(239,68,68,0.03)'
      }} data-id="element-80">
          <div className="flex items-center gap-2" data-id="element-81">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-82" />
            <span className="text-gray-300 text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-83">
              Cierra en
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-84">
            <div className="flex flex-col items-center" data-id="element-85">
              <span className="text-2xl sm:text-3xl font-black text-red-500 leading-none tracking-tighter px-3 py-1.5 rounded-lg" style={{
              background: 'rgba(239,68,68,0.08)',
              textShadow: '0 0 15px rgba(239,68,68,0.5)'
            }} data-id="element-86">
                {formatTime(timeLeft.hours)}
              </span>
              <span className="text-gray-600 text-[8px] font-bold mt-1 uppercase tracking-widest" data-id="element-87">
                Hrs
              </span>
            </div>
            <span className="text-xl font-black text-red-500/60 -mt-3" data-id="element-88">:</span>
            <div className="flex flex-col items-center" data-id="element-89">
              <span className="text-2xl sm:text-3xl font-black text-red-500 leading-none tracking-tighter px-3 py-1.5 rounded-lg" style={{
              background: 'rgba(239,68,68,0.08)',
              textShadow: '0 0 15px rgba(239,68,68,0.5)'
            }} data-id="element-90">
                {formatTime(timeLeft.minutes)}
              </span>
              <span className="text-gray-600 text-[8px] font-bold mt-1 uppercase tracking-widest" data-id="element-91">
                Min
              </span>
            </div>
            <span className="text-xl font-black text-red-500/60 -mt-3" data-id="element-92">:</span>
            <div className="flex flex-col items-center" data-id="element-93">
              <span className="text-2xl sm:text-3xl font-black text-red-500 leading-none tracking-tighter px-3 py-1.5 rounded-lg" style={{
              background: 'rgba(239,68,68,0.08)',
              textShadow: '0 0 15px rgba(239,68,68,0.5)'
            }} data-id="element-94">
                {formatTime(timeLeft.seconds)}
              </span>
              <span className="text-gray-600 text-[8px] font-bold mt-1 uppercase tracking-widest" data-id="element-95">
                Seg
              </span>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col gap-4 mb-8" data-id="element-96">
          <div onClick={() => setSelectedPack('basic')} className={`w-full rounded-xl p-5 sm:p-6 cursor-pointer transition-all duration-200 flex items-start gap-4 ${selectedPack === 'basic' ? 'bg-[#101840] border-2 border-brand-cyan shadow-[0_0_20px_rgba(0,212,255,0.15)]' : 'bg-[#0a0f2e] border border-gray-700 hover:border-gray-500'}`} data-id="element-97">
            <div className="shrink-0 mt-1" data-id="element-98">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'basic' ? 'border-brand-cyan' : 'border-gray-600'}`} data-id="element-99">
                {selectedPack === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-brand-cyan" data-id="element-100" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-101">
              <div className="flex flex-col" data-id="element-102">
                <h3 className="text-base sm:text-lg font-bold text-white mb-0.5 flex items-center gap-2" data-id="element-103">
                  <span data-id="element-104">🛡️</span> MEGA PACK CUENTA BLINDADA
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-105">6 Tomos + 6 Bonos</p>
                <p className="text-brand-cyan text-xs font-medium mt-1" data-id="element-106">
                  Ideal para: Todos los casos de seguridad bancaria y digital
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-107">
                <span className="text-red-400/80 text-[9px] font-extrabold uppercase tracking-wider border border-red-400/20 bg-red-400/10 px-1.5 py-0.5 rounded mb-1" data-id="element-108">
                  50% OFF
                </span>
                <span className="text-gray-500 line-through text-xs" data-id="element-109">
                  $39.998
                </span>
                <span className="text-2xl sm:text-3xl font-extrabold text-white leading-tight" data-id="element-110">
                  $19.999 ARS
                </span>
              </div>
            </div>
          </div>

          <div onClick={() => setSelectedPack('pro')} className={`w-full rounded-xl p-5 sm:p-6 cursor-pointer transition-all duration-200 flex items-start gap-4 ${selectedPack === 'pro' ? 'bg-[#101840] border-2 border-brand-cyan shadow-[0_0_20px_rgba(0,212,255,0.15)]' : 'bg-[#0a0f2e] border border-gray-700 hover:border-gray-500'}`} data-id="element-111">
            <div className="shrink-0 mt-1" data-id="element-112">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'pro' ? 'border-brand-cyan' : 'border-gray-600'}`} data-id="element-113">
                {selectedPack === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand-cyan" data-id="element-114" />}
              </div>
            </div>
            <div className="flex-grow flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-115">
              <div className="flex flex-col" data-id="element-116">
                <div className="text-2xl mb-1" data-id="element-117">🏆</div>
                <h3 className="text-base sm:text-lg font-bold text-white mb-0.5" data-id="element-118">
                  MEGA PACK + SERIE BLACK
                </h3>
                <div className="text-brand-cyan text-lg mb-1" data-id="element-119">⭐</div>
                <p className="text-gray-400 text-sm" data-id="element-120">
                  6 Tomos + 6 Bonos + 4 Tomos Serie Black
                </p>
                <p className="text-brand-cyan text-xs font-medium mt-1" data-id="element-121">
                  Ideal para: Quienes quieren el sistema de protección más
                  completo
                </p>
              </div>
              <div className="flex flex-col items-start sm:items-end shrink-0" data-id="element-122">
                <span className="text-red-400/80 text-[9px] font-extrabold uppercase tracking-wider border border-red-400/20 bg-red-400/10 px-1.5 py-0.5 rounded mb-1" data-id="element-123">
                  50% OFF
                </span>
                <span className="text-gray-500 line-through text-xs" data-id="element-124">
                  $55.998
                </span>
                <span className="text-2xl sm:text-3xl font-extrabold text-brand-cyan leading-tight" data-id="element-125">
                  $27.999 ARS
                </span>
              </div>
            </div>
          </div>
        </div>

        <button onClick={() => setIsModalOpen(true)} className="w-full text-black font-bold text-lg sm:text-xl py-5 px-8 rounded-xl transition-all transform hover:scale-105 block text-center" style={{
        background: '#FF9900',
        boxShadow: '0 0 25px rgba(255,153,0,0.3)'
      }} onMouseEnter={e => {
        e.currentTarget.style.background = '#e68a00';
        e.currentTarget.style.boxShadow = '0 0 35px rgba(255,153,0,0.5)';
      }} onMouseLeave={e => {
        e.currentTarget.style.background = '#FF9900';
        e.currentTarget.style.boxShadow = '0 0 25px rgba(255,153,0,0.3)';
      }} data-id="element-126">
          {selectedPack === 'basic' ? '→ QUIERO MI MEGAPACK' : '→ QUIERO EL MEGAPACK + SERIE BLACK'}
        </button>
      </motion.div>

      <OrderBumpModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} selectedPack={selectedPack} data-id="element-127" />
    </section>;
}